import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IUserSlice, TCart, TUser } from "@/redux/slices/user/types";

export const logOut = createAsyncThunk(
  "user/logout",
  async () =>
    await axios({
      method: "GET",
      url: `/svc/logout/`,
    }).then((res) => res.data)
);

const pending = (state: IUserSlice) => {
  state.user.loading = true;
};

const fulfilled = (
  state: IUserSlice,
  { payload }: { payload: { cart: TCart; user: TUser } },
) => {
  state.user = {
    loading: false,
    authenticated: false,
    addresses: {
      options: [],
      loading: false,
    },
    payment_options: {
      options: [],
      loading: false,
    },
    call_credit: {
      balance: null,
    },
  };
  state.cart = {
    token: null,
    cost_gross: 0,
    cost_net: 0,
    items: [],
    loading: false,
    ns_groups: {},
  };
};

const rejected = (state: IUserSlice) => {
  state.user.loading = false;
};

export default {
  action: logOut,
  fulfilled,
  pending,
  rejected,
};
